<template>
<div class="chapter">
<div class="inner_page">
<p style="text-align:center; margin-top:5pc"></p>
<p class="dedication"><a id="page_5"></a>For Tara</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 03dedication.vue?6b20e206